import { render, staticRenderFns } from "./WeeklyEmails.vue?vue&type=template&id=54b51c90&scoped=true&"
import script from "./WeeklyEmails.vue?vue&type=script&lang=js&"
export * from "./WeeklyEmails.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyEmails.vue?vue&type=style&index=0&id=54b51c90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b51c90",
  null
  
)

export default component.exports